var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5742 17.7257L11.5701 17.7445L7.56649 20.3985C7.55281 20.4083 7.53386 20.3985 7.53386 20.3817V17.7152H5.57825C4.1627 17.7152 3.01562 16.5679 3.01562 15.1526V7.88098C3.01562 6.46567 4.1627 5.31836 5.57825 5.31836H16.4384C17.8537 5.31836 19.001 6.46567 19.001 7.88098V15.1526C19.001 16.5679 17.8537 17.7152 16.4384 17.7152L15.3913 17.7257H12.5742Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04981 10.6424C8.86261 10.6424 9.5215 9.98346 9.5215 9.17066C9.5215 8.35787 8.86261 7.69897 8.04981 7.69897C7.23702 7.69897 6.57812 8.35787 6.57812 9.17066C6.57812 9.98346 7.23702 10.6424 8.04981 10.6424Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9639 10.6424C14.7767 10.6424 15.4356 9.98346 15.4356 9.17066C15.4356 8.35787 14.7767 7.69897 13.9639 7.69897C13.1511 7.69897 12.4922 8.35787 12.4922 9.17066C12.4922 9.98346 13.1511 10.6424 13.9639 10.6424Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0425 13.6392V9.52881H20.1576C20.6228 9.52881 21 9.90597 21 10.3712V12.797C21 13.2623 20.6228 13.6394 20.1576 13.6394H19.0425V13.6392ZM1 12.797V10.3712C1 9.90597 1.37716 9.52881 1.84237 9.52881H2.95753V13.6394H1.84237C1.37716 13.6392 1 13.262 1 12.797ZM14.1156 12.9647C13.91 14.4405 12.5674 15.5799 10.941 15.5799C9.31502 15.5799 7.97193 14.4405 7.76632 12.9647H14.1156Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9437 3.01248C11.4995 3.01248 11.95 2.56197 11.95 2.00624C11.95 1.45051 11.4995 1 10.9437 1C10.388 1 9.9375 1.45051 9.9375 2.00624C9.9375 2.56197 10.388 3.01248 10.9437 3.01248Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 4.27637V3.01245",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.8b4ddf69d64823d95fb5eed782514fe2.svg";
export { ForwardRef as ReactComponent };